import React, { createContext, useContext, useEffect, useState } from 'react';
import {
    DEFAULT_CURRENCY,
    formatCurrencyAmount,
    getCurrencyMeta,
    getPreferredCurrency,
    getPreferredCurrencyAsync,
    normalizeCurrency,
    persistCurrency
} from './currency';

const CurrencyContext = createContext({
    currency: DEFAULT_CURRENCY,
    currencyMeta: getCurrencyMeta(DEFAULT_CURRENCY),
    setCurrencyPreference: () => {},
    formatCurrency: (amount) => String(amount)
});

export function CurrencyProvider({ children, locale }) {
    const [currency, setCurrency] = useState(() => getPreferredCurrency());

    // On first visit (no saved preference) auto-detect from the visitor's IP.
    useEffect(() => {
        let cancelled = false;

        getPreferredCurrencyAsync().then((detectedCurrency) => {
            if (!cancelled) {
                setCurrency(normalizeCurrency(detectedCurrency));
            }
        });

        return () => { cancelled = true; };
    }, []);

    function setCurrencyPreference(nextCurrency) {
        const normalizedCurrency = persistCurrency(nextCurrency);
        setCurrency(normalizedCurrency);
    }

    function formatCurrency(amount) {
        return formatCurrencyAmount(amount, currency, locale);
    }

    return (
        <CurrencyContext.Provider
            value={{
                currency,
                currencyMeta: getCurrencyMeta(currency),
                setCurrencyPreference,
                formatCurrency
            }}
        >
            {children}
        </CurrencyContext.Provider>
    );
}

export function useCurrency() {
    return useContext(CurrencyContext);
}
